// import React, {Component} from 'react';
import {
  View,
  Text
} from 'react-native';

import ff from './ff';
import bf from './bf';
import ic from './ic';
import cf from './cf';
import ce from './ce';
import cr from './cr';

import c30v1a from './c30v1a'; // 団体情報
import c70v1a from './c70v1a'; // 祝日情報
import i10v1a from './i10v1a'; // 設備情報
import i11v1a from './i11v1a'; // 時間帯情報
import i14v1a from './i14v1a'; // 設定情報

import c51v1a from './c51v1a';

import cView from './cView';

import myPD from './myPD_20211208';

import i11v from './i11v_20211024';
import i15v from './i15v_20211024';
import i1zv from './i1zv_20211024';

import myWB from './myWB_20211212';
import myXL from './myXL_20211211';

export default class i1zv6 extends i1zv { // 設備予約　管理用用画面

// $opb_chk, render は個別に実装

$clp_loadLists = () => [
  new Promise( _o_end1 => {
    let _qry = cf.c('i1zr');
    _qry = `SELECT DISTINCT SUBSTRING(i1zri21d, 1, 7) AS mth FROM t_i1zr WHERE ${_qry};`;
    cf.myCB_call_slc({
      elm: 'i1zr',
      n_dms: 3,
      qry: _qry,
    })
    .then( _ld_is => {
      let _ld_is2 = _ld_is.map( _d_is => {
        let _d = {
          key: _d_is.mth,
          pfx: _d_is.mth,
        };
        return _d;
      })
      cf.myRN_setStt({
        sld_mthss: _ld_is2,
      })
      .then(() => {
        _o_end1();
      });
    });
  }),
];

_eptExl1 = async () => {

  cf.s();

  let _mth = global.t?.state.s_mth;

  const _dates = ff.myDT_cnv('dates', {
    stt: ff.myDT_cnv('fdm', `${_mth}-01`),
    end: ff.myDT_cnv('ldm', `${_mth}-01`),
  })

  const _hdys = []; // holiday
  await c70v1a.op_loadList({
    elm: 'c700',
    o_cnd: _dd_datss => {
      let _cnd = cf.c('c700', `c700i11d like "${_mth}%"`, true, false);
      return _cnd;
    },
  });
  global.t?.state.sdld_c700Listsss?.c700?.map( _c700z => {
    _hdys.push(_c700z.d_flds.c700i11d);
  })

  const _ld_shtss= [];

  let _sht = `室(${_mth})`;

  let _ld_hdrss = [
    { key:  1, header: '時間帯区分', width: 20, style: {} },
    { key:  2, header: '室', width: 20, style: {}  },
    { key:  3, header: '集計対象', width: 20, style: {}  },
    { key:  4, header: '時間帯', width: 20, style: {}  },
    { key:  5, header: '全体', width: 10, style: {}  },
    { key:  6, header: '平日', width: 10, style: {}  },
    { key:  7, header: '土曜', width: 10, style: {}  },
    { key:  8, header: '日曜祝日', width: 10, style: {}  },
  ];
  _dates.map( (_date, _idx) => {
    _ld_hdrss.push({
      key: _idx + 9,
      header: `${ff.myDT_cnv('day', _date)}(${ff.myDT_cnv('dow', _date)})`,
      width: 5,
      style: {}
    });
  });

  await i11v.op_loadList({
    elm: 'i11r',
    dd_cldDefss: {
      i10r: {
        elm: 'i10r',
        o_cnd: _dd_datss => {
          let _cnd = cf.c('i10r', `i10rb51f = ${_dd_datss.i11r.d_flds._fst} AND i10rt11i = 200`)
          return _cnd;
        },
        dd_cldDefss: {
          i1zr: {
            elm: 'i1zr',
            o_cnd: _dd_datss => {
              let _cnd = cf.c('c30r', `t_c30r.c30rc31s <> "予約不可" AND t_c30r._fst = t_i1zr.i1zrb31f`);
              _cnd = cf.c('i1zr', `i1zrb41f = ${_dd_datss.i10r.d_flds._fst} AND i1zri21d LIKE "${_mth}%" AND i1zrs11i IN (80, 90) AND EXISTS (SELECT * FROM t_c30r WHERE ${_cnd})`);
              return _cnd;
            },

            dd_cldDefss: {
              i1z0: {
                elm: 'i1z0',
                o_cnd: _dd_datss => {
                  let _cnd = cf.c('i1z0', `i1z0b61k = ${_dd_datss.i1zr.d_flds._key}`, false, false);
                  return _cnd;
                },
                dd_rfrss: {
                  i110: {
                    elm: 'i110',
                    o_cnd: _d_flds => {
                      let _cnd = cf.c('i110', `t_i110._fst = (${_d_flds.i1z0b51f})`);
                      return _cnd;
                    },
                  },
                },
              },
            },

          },
        },
      },
      i110: {
        elm: 'i110',
        o_cnd: _dd_datss => {
          let _cnd = cf.c('i110', `i110b51k = ${_dd_datss.i11r.d_flds._key}`)
          return _cnd;
        }
      }
    },
  });


  let _ld_bdyss = [];

  const _dz = { '全体': 0, '日曜祝日': 0, '土曜': 0, '平日': 0 };
  _dates.map( _date => _dz[_date] = 0 );
  let _dddd_bdyssss = { '時間帯区分合計': { '室合計': { '申請数': _dz }} };

  global.t?.state.sdld_i11rListsss.i11r.map( _d_i11rs => {
    let _i11rc31s = _d_i11rs.d_flds.i11rc31s ?? ''; // 時間帯区分

    if (!_dddd_bdyssss[_i11rc31s]) {
      const _dz = { '全体': 0, '日曜祝日': 0, '土曜': 0, '平日': 0 };
      _dates.map( _date => _dz[_date] = 0 );
      _dddd_bdyssss[_i11rc31s] = { '室合計': { 'コマ数': {}, '申請数': _dz } };
    }; 

    if (!_dddd_bdyssss[_i11rc31s]['室合計']['コマ数']['時間帯合計']) {
      const _dz = { '全体': 0, '日曜祝日': 0, '土曜': 0, '平日': 0 };
      _dates.map( _date => _dz[_date] = 0 );
      _dddd_bdyssss[_i11rc31s]['室合計']['コマ数']['時間帯合計'] = _dz;
    }

    if (_d_i11rs.dld_cldDatsss.i10r.length > 0) {

      _d_i11rs.dld_cldDatsss.i10r.map( _d_i10rs => {

        let _i10rc31s = _d_i10rs.d_flds.i10rc31s ?? ''; // 室

        if (!_dddd_bdyssss[_i11rc31s][_i10rc31s]) {
          const _dz = { '全体': 0, '日曜祝日': 0, '土曜': 0, '平日': 0 };
          _dates.map( _date => _dz[_date] = 0 );
          _dddd_bdyssss[_i11rc31s][_i10rc31s] = { 'コマ数': {}, '申請数': _dz };
        };

        if (!_dddd_bdyssss[_i11rc31s][_i10rc31s]['コマ数']['時間帯合計']) {
          const _dz = { '全体': 0, '日曜祝日': 0, '土曜': 0, '平日': 0 };
          _dates.map( _date => _dz[_date] = 0 );
          _dddd_bdyssss[_i11rc31s][_i10rc31s]['コマ数']['時間帯合計'] = _dz;
        }

        if (_d_i10rs.dld_cldDatsss.i1zr.length > 0) {

          _d_i10rs.dld_cldDatsss.i1zr.map( _d_i1zrs => { // 予約情報

            const _date = _d_i1zrs.d_flds.i1zri21d; // 利用日

            const _dateType = 
              ( ff.i(ff.myDT_cnv('dow', _date), ['日']) || ff.i(_date, _hdys) ) ? // 祝日
                '日曜祝日'
              :( ff.i(ff.myDT_cnv('dow', _date), ['土']) ) ? // 土
                '土曜'
              : '平日'; // 日付種別

            // 申請数の集計

            _dddd_bdyssss[_i11rc31s][_i10rc31s]['申請数']['全体'] += 1;
            _dddd_bdyssss[_i11rc31s][_i10rc31s]['申請数'][_dateType] += 1;
            _dddd_bdyssss[_i11rc31s][_i10rc31s]['申請数'][_date] += 1;

/*
            _dddd_bdyssss[_i11rc31s]['室合計']['コマ数']['時間帯合計']['全体'] += 1;
            _dddd_bdyssss[_i11rc31s]['室合計']['コマ数']['時間帯合計'][_dateType] += 1;
            _dddd_bdyssss[_i11rc31s]['室合計']['コマ数']['時間帯合計'][_date] += 1;
*/

            _dddd_bdyssss[_i11rc31s]['室合計']['申請数']['全体'] += 1;
            _dddd_bdyssss[_i11rc31s]['室合計']['申請数'][_dateType] += 1;
            _dddd_bdyssss[_i11rc31s]['室合計']['申請数'][_date] += 1;

            _dddd_bdyssss['時間帯区分合計']['室合計']['申請数']['全体'] += 1;
            _dddd_bdyssss['時間帯区分合計']['室合計']['申請数'][_dateType] += 1;
            _dddd_bdyssss['時間帯区分合計']['室合計']['申請数'][_date] += 1;

            _d_i11rs.dld_cldDatsss.i110.map( _d_i110s => {

              let _i110c31s = _d_i110s.d_flds.i110c31s ?? ''; // 時間帯

              if (!_dddd_bdyssss[_i11rc31s][_i10rc31s]['コマ数'][_i110c31s]) {
                const _dz = { '全体': 0, '日曜祝日': 0, '土曜': 0, '平日': 0 };
                _dates.map( _date => _dz[_date] = 0 );
                _dddd_bdyssss[_i11rc31s][_i10rc31s]['コマ数'][_i110c31s] = _dz;
              };

              if (!_dddd_bdyssss[_i11rc31s]['室合計']['コマ数'][_i110c31s]) {
                const _dz = { '全体': 0, '日曜祝日': 0, '土曜': 0, '平日': 0 };
                _dates.map( _date => _dz[_date] = 0 );
                _dddd_bdyssss[_i11rc31s]['室合計']['コマ数'][_i110c31s] = _dz;
              }

              if (_d_i1zrs.dld_cldDatsss.i1z0.length > 0) {

                _d_i1zrs.dld_cldDatsss?.i1z0.map( _d_i1z0s => {

                  if ( _d_i1z0s.d_flds.i1z0b51f == _d_i110s.d_flds._fst) {

                    // コマ数の集計

                    _dddd_bdyssss[_i11rc31s][_i10rc31s]['コマ数'][_i110c31s]['全体'] += 1;
                    _dddd_bdyssss[_i11rc31s][_i10rc31s]['コマ数'][_i110c31s][_dateType] += 1;
                    _dddd_bdyssss[_i11rc31s][_i10rc31s]['コマ数'][_i110c31s][_date] += 1;

                    _dddd_bdyssss[_i11rc31s][_i10rc31s]['コマ数']['時間帯合計']['全体'] += 1;
                    _dddd_bdyssss[_i11rc31s][_i10rc31s]['コマ数']['時間帯合計'][_dateType] += 1;
                    _dddd_bdyssss[_i11rc31s][_i10rc31s]['コマ数']['時間帯合計'][_date] += 1;

                    _dddd_bdyssss[_i11rc31s]['室合計']['コマ数'][_i110c31s]['全体'] += 1;
                    _dddd_bdyssss[_i11rc31s]['室合計']['コマ数'][_i110c31s][_dateType] += 1;
                    _dddd_bdyssss[_i11rc31s]['室合計']['コマ数'][_i110c31s][_date] += 1;

                    _dddd_bdyssss[_i11rc31s]['室合計']['コマ数']['時間帯合計']['全体'] += 1;
                    _dddd_bdyssss[_i11rc31s]['室合計']['コマ数']['時間帯合計'][_dateType] += 1;
                    _dddd_bdyssss[_i11rc31s]['室合計']['コマ数']['時間帯合計'][_date] += 1;

                  };
                });
              };
            });

          });

          _d_i11rs.dld_cldDatsss.i110.map( _d_i110s => {

            let _i110c31s = _d_i110s.d_flds.i110c31s ?? ''; // 予約情報

            const _dz = {
              1: _i11rc31s,
              2: _i10rc31s,
              3: 'コマ数',
              4: _i110c31s,
              5: _dddd_bdyssss[_i11rc31s][_i10rc31s]['コマ数'][_i110c31s]['全体'],
              6: _dddd_bdyssss[_i11rc31s][_i10rc31s]['コマ数'][_i110c31s]['平日'],
              7: _dddd_bdyssss[_i11rc31s][_i10rc31s]['コマ数'][_i110c31s]['土曜'],
              8: _dddd_bdyssss[_i11rc31s][_i10rc31s]['コマ数'][_i110c31s]['日曜祝日'],
            }
            _dates.map( (_date, _idx) => _dz[_idx + 9] = _dddd_bdyssss[_i11rc31s][_i10rc31s]['コマ数'][_i110c31s][_date]);
            _ld_bdyss.push(_dz);
          });

          const _dz2 = {
            1: _i11rc31s,
            2: _i10rc31s,
            3: 'コマ数',
            4: '時間帯合計',
            5: _dddd_bdyssss[_i11rc31s][_i10rc31s]['コマ数']['時間帯合計']['全体'],
            6: _dddd_bdyssss[_i11rc31s][_i10rc31s]['コマ数']['時間帯合計']['平日'],
            7: _dddd_bdyssss[_i11rc31s][_i10rc31s]['コマ数']['時間帯合計']['土曜'],
            8: _dddd_bdyssss[_i11rc31s][_i10rc31s]['コマ数']['時間帯合計']['日曜祝日'],
          };
          _dates.map( (_date, _idx) => _dz2[_idx + 9] = _dddd_bdyssss[_i11rc31s][_i10rc31s]['コマ数']['時間帯合計'][_date]);
          _ld_bdyss.push(_dz2);

          const _dz3 = {
            1: _i11rc31s,
            2: _i10rc31s,
            3: '申請数',
            4: '',
            5: _dddd_bdyssss[_i11rc31s][_i10rc31s]['申請数']['全体'],
            6: _dddd_bdyssss[_i11rc31s][_i10rc31s]['申請数']['平日'],
            7: _dddd_bdyssss[_i11rc31s][_i10rc31s]['申請数']['土曜'],
            8: _dddd_bdyssss[_i11rc31s][_i10rc31s]['申請数']['日曜祝日'],
          };
          _dates.map( (_date, _idx) => _dz3[_idx + 9] = _dddd_bdyssss[_i11rc31s][_i10rc31s]['申請数'][_date]);
          _ld_bdyss.push(_dz3);
        };
      
      });

      if (_d_i11rs.dld_cldDatsss.i110.length > 0) {
        _d_i11rs.dld_cldDatsss.i110.map( _d_i110s => { // 時間帯区分
          let _i110c31s = _d_i110s.d_flds.i110c31s ?? '';
          const _dz = {
            1: _i11rc31s,
            2: '室合計',
            3: 'コマ数',
            4: _i110c31s,
            5: _dddd_bdyssss[_i11rc31s]['室合計']['コマ数'][_i110c31s]?.['全体'] ?? 0,
            6: _dddd_bdyssss[_i11rc31s]['室合計']['コマ数'][_i110c31s]?.['平日'] ?? 0,
            7: _dddd_bdyssss[_i11rc31s]['室合計']['コマ数'][_i110c31s]?.['土曜'] ?? 0,
            8: _dddd_bdyssss[_i11rc31s]['室合計']['コマ数'][_i110c31s]?.['日曜祝日'] ?? 0,
          };
          _dates.map( (_date, _idx) => _dz[_idx + 9] = _dddd_bdyssss[_i11rc31s]['室合計']['コマ数'][_i110c31s]?.[_date] ?? 0);
          _ld_bdyss.push(_dz);
        });

        const _dz2 = {
          1: _i11rc31s,
          2: '室合計',
          3: 'コマ数',
          4: '時間帯合計',
          5: _dddd_bdyssss[_i11rc31s]['室合計']['コマ数']['時間帯合計']['全体'],
          6: _dddd_bdyssss[_i11rc31s]['室合計']['コマ数']['時間帯合計']['平日'],
          7: _dddd_bdyssss[_i11rc31s]['室合計']['コマ数']['時間帯合計']['土曜'],
          8: _dddd_bdyssss[_i11rc31s]['室合計']['コマ数']['時間帯合計']['日曜祝日'],
        };
        _dates.map( (_date, _idx) => _dz2[_idx + 9] = _dddd_bdyssss[_i11rc31s]['室合計']['コマ数']['時間帯合計'][_date]);
        _ld_bdyss.push(_dz2);

        const _dz3 = {
          1: _i11rc31s,
          2: '室合計',
          3: '申請数',
          4: '',
          5: _dddd_bdyssss[_i11rc31s]['室合計']['申請数']['全体'],
          6: _dddd_bdyssss[_i11rc31s]['室合計']['申請数']['平日'],
          7: _dddd_bdyssss[_i11rc31s]['室合計']['申請数']['土曜'],
          8: _dddd_bdyssss[_i11rc31s]['室合計']['申請数']['日曜祝日'],
        };
        _dates.map( (_date, _idx) => _dz3[_idx + 9] = _dddd_bdyssss[_i11rc31s]['室合計']['申請数'][_date]);
        _ld_bdyss.push(_dz3);
      };
    };
  });

  const _dz2 = {
    1: '時間帯区分合計',
    2: '室合計',
    3: '申請数',
    4: '',
    5: _dddd_bdyssss['時間帯区分合計']['室合計']['申請数']['全体'],
    6: _dddd_bdyssss['時間帯区分合計']['室合計']['申請数']['平日'],
    7: _dddd_bdyssss['時間帯区分合計']['室合計']['申請数']['土曜'],
    8: _dddd_bdyssss['時間帯区分合計']['室合計']['申請数']['日曜祝日'],
  };
  _dates.map( (_date, _idx) => _dz2[_idx + 9] = _dddd_bdyssss['時間帯区分合計']['室合計']['申請数'][_date]);
  _ld_bdyss.push(_dz2);

  _ld_shtss.push({
    sht: _sht,
    ld_hdrss: _ld_hdrss,
    ld_bdyss: _ld_bdyss,
  });

  _sht = `団体種別(${_mth})`;

  _ld_hdrss = [
    { key:  1, header: '団体種別', width: 20, style: {} },
    { key:  2, header: '集計対象', width: 20, style: {}  },
    { key:  3, header: '全体', width: 10, style: {}  },
    { key:  4, header: '平日', width: 10, style: {}  },
    { key:  5, header: '土曜', width: 10, style: {}  },
    { key:  6, header: '日曜祝日', width: 10, style: {}  },
  ];
  _dates.map( (_date, _idx) => {
    _ld_hdrss.push({
      key:  _idx + 7, 
      header: `${ff.myDT_cnv('day', _date)}(${ff.myDT_cnv('dow', _date)})`,
      width: 5, 
      style: {}
    });
  });

  _ld_bdyss = [];

  await i15v.op_loadList({
    elm: 'i15r',
    dd_cldDefss: {
      c30r: {
        elm: 'c30r',
        o_cnd: _dd_datss => {
          let _cnd = cf.c('c30r', `t_c30r.c30rbk1f = ${_dd_datss.i15r.d_flds._fst} AND t_c30r.c30rc31s <> "予約不可"`);
          return _cnd;
        },
        dd_cldDefss: {
          i1zr: {
            elm: 'i1zr',
            o_cnd: _dd_datss => {
              let _cnd = cf.c('i1zr', `i1zrb31f = ${_dd_datss.c30r.d_flds._fst} AND i1zri21d LIKE "${_mth}%" AND i1zrs11i IN (80, 90)`);
              return _cnd;
            },
            dd_cldDefss: {
              i1z0: {
                elm: 'i1z0',
                o_cnd: _dd_datss => {
                  let _cnd = cf.c('i1z0', `i1z0b61k = ${_dd_datss.i1zr.d_flds._key}`, false, false);
                  return _cnd;
                },
                dd_rfrss: {
                  i110: {
                    elm: 'i110',
                    o_cnd: _d_flds => {
                      let _cnd = cf.c('i110', `t_i110._fst = (${_d_flds.i1z0b51f})`);
                      return _cnd;
                    },
                  },
                },
              },
            },

          },
        },
      }
    },
  })

  const _dzB1a = { '全体': 0, '平日': 0, '土曜':0, '日曜祝日':0 }
  _dates.map( _date => _dzB1a[_date] = 0);
  const _dzB1b = { '全体': 0, '平日': 0, '土曜':0, '日曜祝日':0 }
  _dates.map( _date => _dzB1b[_date] = 0);
  const _dzB1c = { '全体': 0, '平日': 0, '土曜':0, '日曜祝日':0 }
  _dates.map( _date => _dzB1c[_date] = 0);
  let _dd_Allbdyss = { '申請数': _dzB1a, 'コマ数': _dzB1b, '人数': _dzB1c };
  global.t?.state.sdld_i15rListsss.i15r.map( _d_i15rs => {
    let _i15rc31s = _d_i15rs.d_flds.i15rc31s;
    const _dzB2a = { '全体': 0, '平日': 0, '土曜':0, '日曜祝日':0 }
    _dates.map( _date => _dzB2a[_date] = 0);
    const _dzB2b = { '全体': 0, '平日': 0, '土曜':0, '日曜祝日':0 }
    _dates.map( _date => _dzB2b[_date] = 0);
    const _dzB2c = { '全体': 0, '平日': 0, '土曜':0, '日曜祝日':0 }
    _dates.map( _date => _dzB2c[_date] = 0);
    let _dd_bdyss = { '申請数': _dzB2a, 'コマ数': _dzB2b, '人数': _dzB2c  };
    if (_d_i15rs.dld_cldDatsss?.c30r?.length > 0) {
      _d_i15rs.dld_cldDatsss.c30r.map( _d_c30rs => {
        if (_d_c30rs.dld_cldDatsss?.i1zr?.length > 0) {
          _d_c30rs.dld_cldDatsss.i1zr.map( _d_i1zrs => {

            const _date = _d_i1zrs.d_flds.i1zri21d; // 利用日

            const _dateType = 
              ( ff.i(ff.myDT_cnv('dow', _date), ['日']) || ff.i(_date, _hdys) ) ? // 祝日、土日
                '日曜祝日'
              : ( ff.i(ff.myDT_cnv('dow', _date), ['土']) ) ? // 祝日、土日
                '土曜'
              : '平日'; // 日付種別

            _dd_bdyss['申請数']['全体'] += 1;
            _dd_bdyss['申請数'][_dateType] += 1;
            _dd_bdyss['申請数'][_date] += 1;
            _dd_bdyss['人数']['全体'] += ff.n(_d_i1zrs.d_flds.i1zri41i);
            _dd_bdyss['人数'][_dateType] += ff.n(_d_i1zrs.d_flds.i1zri41i);
            _dd_bdyss['人数'][_date] += ff.n(_d_i1zrs.d_flds.i1zri41i);
            _dd_Allbdyss['申請数']['全体'] += 1;
            _dd_Allbdyss['申請数'][_dateType] += 1;
            _dd_Allbdyss['申請数'][_date] += 1;
            _dd_Allbdyss['人数']['全体'] += ff.n(_d_i1zrs.d_flds.i1zri41i);
            _dd_Allbdyss['人数'][_dateType] += ff.n(_d_i1zrs.d_flds.i1zri41i);
            _dd_Allbdyss['人数'][_date] += ff.n(_d_i1zrs.d_flds.i1zri41i);
            if (_d_i1zrs.dld_cldDatsss?.i1z0?.length > 0) {
              _d_i1zrs.dld_cldDatsss.i1z0.map( _d_i1z0s => {
                _dd_bdyss['コマ数']['全体'] += 1;
                _dd_bdyss['コマ数'][_dateType] += 1;
                _dd_bdyss['コマ数'][_date] += 1;
                _dd_Allbdyss['コマ数']['全体'] += 1;
                _dd_Allbdyss['コマ数'][_dateType] += 1;
                _dd_Allbdyss['コマ数'][_date] += 1;
              });
            };

          });
        };
      });
    };

    const _dzB3a = {
      1: _i15rc31s,
      2: '申請数',
      3: _dd_bdyss['申請数']['全体'],
      4: _dd_bdyss['申請数']['平日'],
      5: _dd_bdyss['申請数']['土曜'],
      6: _dd_bdyss['申請数']['日曜祝日'],
    };
    _dates.map( (_date, _idx) => _dzB3a[_idx + 7] = _dd_bdyss['申請数'][_date]);
    _ld_bdyss.push(_dzB3a);

    const _dzB3b = {
      1: _i15rc31s,
      2: 'コマ数',
      3: _dd_bdyss['コマ数']['全体'],
      4: _dd_bdyss['コマ数']['平日'],
      5: _dd_bdyss['コマ数']['土曜'],
      6: _dd_bdyss['コマ数']['日曜祝日'],
    };
    _dates.map( (_date, _idx) => _dzB3b[_idx + 7] = _dd_bdyss['コマ数'][_date]);
    _ld_bdyss.push(_dzB3b);

    const _dzB3c = {
      1: _i15rc31s,
      2: '人数',
      3: _dd_bdyss['人数']['全体'],
      4: _dd_bdyss['人数']['平日'],
      5: _dd_bdyss['人数']['土曜'],
      6: _dd_bdyss['人数']['日曜祝日'],
    };
    _dates.map( (_date, _idx) => _dzB3c[_idx + 7] = _dd_bdyss['人数'][_date]);
    _ld_bdyss.push(_dzB3c);

  });

  const _dzB4a = {
    1: '団体種別合計',
    2: '申請数',
    3: _dd_Allbdyss['申請数']['全体'],
    4: _dd_Allbdyss['申請数']['平日'],
    5: _dd_Allbdyss['申請数']['土曜'],
    6: _dd_Allbdyss['申請数']['日曜祝日'],
  };
  _dates.map( (_date, _idx) => _dzB4a[_idx + 7] = _dd_Allbdyss['申請数'][_date]);
  _ld_bdyss.push(_dzB4a);

  const _dzB4b = {
    1: '団体種別合計',
    2: 'コマ数',
    3: _dd_Allbdyss['コマ数']['全体'],
    4: _dd_Allbdyss['コマ数']['平日'],
    5: _dd_Allbdyss['コマ数']['土曜'],
    6: _dd_Allbdyss['コマ数']['日曜祝日'],
  };
  _dates.map( (_date, _idx) => _dzB4b[_idx + 7] = _dd_Allbdyss['コマ数'][_date]);
  _ld_bdyss.push(_dzB4b);

  const _dzB4c = {
    1: '団体種別合計',
    2: '人数',
    3: _dd_Allbdyss['人数']['全体'],
    4: _dd_Allbdyss['人数']['平日'],
    5: _dd_Allbdyss['人数']['土曜'],
    6: _dd_Allbdyss['人数']['日曜祝日'],
  };
  _dates.map( (_date, _idx) => _dzB4c[_idx + 7] = _dd_Allbdyss['人数'][_date]);
  _ld_bdyss.push(_dzB4c);

  _ld_shtss.push({
    sht: _sht,
    ld_hdrss: _ld_hdrss,
    ld_bdyss: _ld_bdyss,
  });

  await myXL.myXL_dwlFile({
    n_ver: 2,
    file: `実績集計表_${ff.myDT_getDate('today').replace(/-/g, '')}.xlsx`,
    ld_shtss: _ld_shtss,
  })

  cf.h();

};

render() {
//ff.l('i1zv6 359: {}'.f(global.t?.state.sdld_i1zrSlcListsss))
  return (
    ce.c(ce.RootDtl, 
      {
        key: -10,
        d_hdrs: {
          pfx:             
            '実績集計表',
          d_subs: 
            ff.i(global.t?.state.sgc_pageMode, ['new', 'edit']) == false ?
              {
                iconName: 'users',
                pfx: 'ユーザ切替',
                o_onPrs: () => {
                  let _d_pageInfs = {
                    sgc_pageRole: global.t?.state.sgc_pageRole,
                    sgc_pageName: 'c00v2a',
                    sgc_pageMode: 'show',
                  };
                  cf.myRN_move_fwd(_d_pageInfs);
                },
              }
            : null,
        },
        d_bdys: {
          l_clds: [
            ce.c(ce.Pnl, {
              key: -10,
              mode: 'list',
              b_vsb: global.t?.state.sgc_pnlMode == 'list' ? true : false,
              d_hdrs: {
                d_ctrs: {
                  l_clds: [
                    ce.c(ce.Pck, cf.f('i1zri21d', { // 利用日
                      pfx: '対象月',
                      key: -1.1, 
                      b_vsb: true,
                      b_edit: true,
                      b_row: true,
                      b_rvs: true,
                      state: 's_mth',
                      n_col: 8,
                      d_stlCtas: {
                        marginLeft: ic.m(1),
                      },
                      ld_iss: global.t?.state.sld_mthss,
                    })),
                  ],
                },
                d_lefts: {
                  l_clds: [
                    ce.c(ce.BtnIconPfx, {
                      key: -1,
                      pfx: '集計実績表（EXCEL）',
                      b_vsb: true,
                      b_row: true,
                      iconName: 'file-o',
                      o_onPrs: () => {
                        cf.myRN_showMdl({
                          mdl: 'cfm',
                          msg: 'ファイルのダウンロードは時間を要しますが、宜しいですか？',
                          ld_btnss: [
                            {
                              pfx: 'はい',
                              o_onPrs: () => {
                                if (ff.f(global.t?.state.s_mth)) {
                                  global.t?._eptExl1();
                                }
                                else {
                                  cf.myRN_showMdl({
                                    mdl: 'cfm',
                                    msg: '対象月を指定してください',
                                    ld_btnss: [
                                      {
                                        pfx: 'はい',
                                        o_onPrs: () => {
                                        },
                                      },
                                    ]
                                  });
                                }
                              },
                            },
                            {
                              pfx: 'いいえ',
                              o_onPrs: () => {
                              },
                            },
                          ]
                        });
                      },
                      d_stlCtas: {
                        marginLeft: ic.s(2),
                      },
                    })
                  ],
                },
              },
              d_bdys: {
                l_clds: [
                ]
              },
            }),
          ],
        }
      }
    )
  );
}

}
